// Mobile Menu with Product Dropdowns
document.addEventListener('DOMContentLoaded', function() {
  // Function to initialize mobile menu with products
  function initMobileMenuWithProducts() {
    const mobileMenuContent = document.querySelector('[data-mobile-menu-content]');
    if (!mobileMenuContent) return;

    // Get product dropdown data
    const dropdownDataElement = document.getElementById('product-dropdowns-data');
    if (!dropdownDataElement) {
      console.warn('No product dropdown data found');
      return;
    }

    let dropdownData;
    try {
      dropdownData = JSON.parse(dropdownDataElement.textContent);
    } catch (e) {
      console.error('Failed to parse dropdown data:', e);
      return;
    }

    // Get the menu from the desktop navigation
    const desktopMenu = document.querySelector('.header__inline-menu .list-menu');
    if (!desktopMenu) {
      console.warn('Desktop menu not found');
      return;
    }

    // Create mobile menu HTML
    const mobileMenuHTML = createMobileMenu(desktopMenu, dropdownData.dropdowns);
    mobileMenuContent.innerHTML = mobileMenuHTML;

    // Initialize collapsible functionality
    initializeCollapsibles();
  }

  // Create mobile menu HTML with product dropdowns
  function createMobileMenu(desktopMenu, dropdowns) {
    const menuItems = desktopMenu.querySelectorAll('.menu-lv-1');
    let html = '<ul class="mobile-nav-list">';

    menuItems.forEach(item => {
      const link = item.querySelector('.menu-lv-1__action');
      if (!link) return;

      const title = link.textContent.trim();
      const href = link.getAttribute('href');

      // Check if this menu item has a product dropdown
      const dropdown = dropdowns.find(d => d.menu_item === title);

      if (dropdown && dropdown.products && dropdown.products.length > 0) {
        // Menu item with product dropdown
        html += `
          <li class="mobile-nav-item has-dropdown">
            <button class="mobile-nav-toggle" data-toggle-submenu aria-expanded="false">
              <span>${title}</span>
              <span class="mobile-nav-arrow">
                <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1 1L6 6L11 1" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </span>
            </button>
            <div class="mobile-nav-dropdown" style="display: none;">
              <div class="mobile-product-grid">
                ${createProductItems(dropdown.products)}
              </div>
            </div>
          </li>
        `;
      } else {
        // Regular menu item
        html += `
          <li class="mobile-nav-item">
            <a href="${href}" class="mobile-nav-link">
              <span>${title}</span>
            </a>
          </li>
        `;
      }
    });

    html += '</ul>';
    return html;
  }

  // Create product items HTML
  function createProductItems(productHandles) {
    if (typeof productHandles === 'string') {
      productHandles = [productHandles];
    }

    return productHandles.map(handle => {
      // For now, create a placeholder. In production, this would fetch product data
      return `
        <a href="/products/${handle}" class="mobile-product-item">
          <div class="mobile-product-image">
            <div class="placeholder-product-image"></div>
          </div>
          <div class="mobile-product-info">
            <h4 class="mobile-product-title">${handle.replace(/-/g, ' ')}</h4>
            <div class="mobile-product-price">
              <span class="price">View Product</span>
            </div>
          </div>
        </a>
      `;
    }).join('');
  }

  // Initialize collapsible functionality
  function initializeCollapsibles() {
    const toggleButtons = document.querySelectorAll('[data-toggle-submenu]');

    toggleButtons.forEach(button => {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        const parent = this.closest('.mobile-nav-item');
        const dropdown = parent.querySelector('.mobile-nav-dropdown');
        const isExpanded = this.getAttribute('aria-expanded') === 'true';

        // Close all other dropdowns
        toggleButtons.forEach(otherButton => {
          if (otherButton !== this) {
            otherButton.setAttribute('aria-expanded', 'false');
            const otherParent = otherButton.closest('.mobile-nav-item');
            const otherDropdown = otherParent.querySelector('.mobile-nav-dropdown');
            if (otherDropdown) {
              otherDropdown.style.display = 'none';
              otherParent.classList.remove('active');
            }
          }
        });

        // Toggle current dropdown
        if (dropdown) {
          if (isExpanded) {
            dropdown.style.display = 'none';
            this.setAttribute('aria-expanded', 'false');
            parent.classList.remove('active');
          } else {
            dropdown.style.display = 'block';
            this.setAttribute('aria-expanded', 'true');
            parent.classList.add('active');
          }
        }
      });
    });
  }

  // Wait for mobile menu to open, then initialize
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.target.classList && mutation.target.classList.contains('menu-open')) {
        setTimeout(initMobileMenuWithProducts, 100);
      }
    });
  });

  // Observe body for menu open class
  const body = document.querySelector('body');
  if (body) {
    observer.observe(body, { attributes: true, attributeFilter: ['class'] });
  }

  // Also try to initialize immediately if menu is already open
  if (document.body.classList.contains('menu-open')) {
    initMobileMenuWithProducts();
  }
});